import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { formatApiError } from "@/lib/api";
import { LOGO_URL } from "@/lib/constants";
import { toast } from "sonner";

export default function CompleteProfile() {
  const { user, loading, completeProfile } = useAuth();
  const navigate = useNavigate();
  const [phone, setPhone] = useState("");
  const [name, setName] = useState("");
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    if (!loading && !user) navigate("/login");
    if (user) { setName(user.name || ""); if (user.profile_complete) navigate("/"); }
  }, [user, loading, navigate]);

  const submit = async (e) => {
    e.preventDefault();
    setErr(""); setBusy(true);
    try {
      await completeProfile(phone, name);
      toast.success("Profile complete. Welcome to OnchainLyfe.");
      navigate("/");
    } catch (ex) {
      setErr(formatApiError(ex.response?.data?.detail) || ex.message);
    } finally { setBusy(false); }
  };

  return (
    <div className="min-h-[calc(100vh-4rem)] grid place-items-center px-6">
      <form onSubmit={submit} className="w-full max-w-sm" data-testid="complete-profile-form">
        <img src={LOGO_URL} alt="OnchainLyfe" className="h-8 mb-8" />
        <h1 className="font-display text-3xl font-bold">One last step</h1>
        <p className="text-zinc-400 text-sm mt-1 mb-6">Add your details to finish setting up your account.</p>
        {err && <div className="mb-4 rounded-lg border border-red-500/30 bg-red-500/10 px-4 py-3 text-sm text-red-400">{err}</div>}
        <label className="block text-xs font-mono-cl tracking-[0.14em] uppercase text-zinc-500 mb-1.5">Name</label>
        <input data-testid="profile-name" value={name} onChange={(e) => setName(e.target.value)}
          className="w-full mb-4 rounded-xl bg-[#0d0d0d] border border-white/10 px-4 py-3 text-sm focus:border-[#ccff00]/50 focus:outline-none" />
        <label className="block text-xs font-mono-cl tracking-[0.14em] uppercase text-zinc-500 mb-1.5">Phone number</label>
        <input data-testid="profile-phone" required value={phone} onChange={(e) => setPhone(e.target.value)}
          className="w-full mb-6 rounded-xl bg-[#0d0d0d] border border-white/10 px-4 py-3 text-sm focus:border-[#ccff00]/50 focus:outline-none" placeholder="+62 812 3456 7890" />
        <button data-testid="profile-submit" disabled={busy} className="w-full py-3 rounded-full bg-[#ccff00] text-black font-semibold text-sm hover:brightness-110 transition-[filter] disabled:opacity-60">
          {busy ? "Saving…" : "Finish"}
        </button>
      </form>
    </div>
  );
}
